exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".lessons-wrapper{display:flex;flex-direction:column;padding:16px 16px 0 16px}.gameText{margin-inline-start:8px}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Videos/src/components/Videos/Video.scss"],"names":[],"mappings":"AAAA,iBACE,aACA,sBACA,wBAAA,CAGF,UACE,uBAAA,CAAA","file":"Video.scss","sourcesContent":[".lessons-wrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 16px 16px 0 16px;\n}\n\n.gameText {\n  margin-inline-start: 8px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./src/components/Videos/Video.scss
// module id = 355
// module chunks = 0 11